import { render, staticRenderFns } from "./grabTodoList.vue?vue&type=template&id=df7077ba&"
import script from "./grabTodoList.vue?vue&type=script&lang=ts&"
export * from "./grabTodoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports